export function trackResetPasswordSubmit({ config }) {
    return {
        event: 'forgotten password - reset',
        eventEffect: 'submit',
        category: {
            primaryCategory: 'sign in',
            subCategory: config.head.appName
        }
    }
}
